import { useQuery } from '@tanstack/react-query'

import { getMerchantOrgBlock } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMerchantOrgBlock = () => {
  const { axiosInstance } = useAxios()

  return useQuery({
    queryFn: () => getMerchantOrgBlock(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_MERCHANT_ORG_BLOCK],
  })
}
